module.exports = __webpack_public_path__ + "img/btn_color.0618443e.svg";